import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { AddressType, toFullAddress } from "../../../../../utils/address";
import { useClaimDetailsContext } from "../ClaimDetailsContext";
import { dateToDisplayDate } from "../../../../../utils/date";

const ResumeInfoClaimWrapper = styled.div`
  border-radius: 0.5em;
  background-color: #fff;
  padding: 0.75em 0;
  margin-bottom: 1em;
  display: flex;
  justify-content: space-around;
  gap: 2em;
  box-shadow: 0 0 2px #aaa;

  .field-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.9em;

    .field-label {
      display: flex;
      text-transform: uppercase;
      letter-spacing: 1px;
      line-height: 1.2em;
    }

    .field-value {
      display: flex;
      line-height: 1.2em;
      margin: 0.25em 0 0 0;
    }
  }
`;

const ResumeInfoClaim = () => {
  const { t } = useTranslation();

  const { claim } = useClaimDetailsContext();

  const placeHappening: AddressType = {
    street: claim?.street,
    civic: claim?.civic,
    city: claim?.city,
    postalCode: claim?.postalCode,
    province: claim?.province,
    country: claim?.country,
  };

  return (
    <ResumeInfoClaimWrapper>
      <div className="field-item">
        <div className="field-label">{t("LABELS.claim-number")}</div>
        <div className="field-value">{claim?.number}</div>
      </div>

      <div className="field-item">
        <div className="field-label">{t("LABELS.company")}</div>
        <div className="field-value">{claim?.company}</div>
      </div>

      <div className="field-item">
        <div className="field-label">{t("LABELS.place-happening")}</div>
        <div className="field-value">{toFullAddress(placeHappening)}</div>
      </div>

      <div className="field-item">
        <div className="field-label">{t("LABELS.date-happening")}</div>
        <div className="field-value">{dateToDisplayDate(claim?.date)}</div>
      </div>

      <div className="field-item">
        <div className="field-label">{t("LABELS.plate-number")}</div>
        <div className="field-value">
          {claim?.policy?.insuredProperty?.plateNumber}
        </div>
      </div>

      <div className="field-item">
        <div className="field-label">{t("LABELS.assigned-guarantee")}</div>
        <div className="field-value">
          {t(`policy-branch-${claim?.claimsBranchCode}`)}
        </div>
      </div>
    </ResumeInfoClaimWrapper>
  );
};

export default ResumeInfoClaim;
